module.exports = __webpack_public_path__ + "assets/img/Employment-Inovations-Landing-Page.1dbd9908.jpg";